import { Block } from '@sanity/types/dist/dts';
import { Grid, Typography } from '@mui/material';

import { PostBase } from '@/components/PostBase/PostBase';
import { RenderSanityBlock } from '@/components/RenderSanityBlock';
import { PostDisplayPropTypes } from './PostDisplaty.types';

function PostDisplay({
  user,
  chipProps,
  publication,
  commentProps,
  link,
  id,
}: PostDisplayPropTypes): JSX.Element {
  let blocks;
  const { body }: { body?: any } = publication || {};
  if (body?.all) {
    blocks = (body.all as unknown) as Array<Block>;
  } else {
    blocks = (body as unknown) as Array<Block>;
  }

  return (
    <PostBase
      link={link}
      user={user}
      chipProps={chipProps}
      commentProps={commentProps}
      publication={publication}
      id={id}
    >
      <Grid
        item
        flexGrow={1}
        width={1}
        display="block"
        css={{ wordBreak: 'break-word' }}
      >
        {publication?.body &&
          (typeof publication?.body === 'string' ? (
            <Typography lineHeight={1.5} variant="body1" whiteSpace="pre-line">
              {publication.body}
            </Typography>
          ) : (
            <RenderSanityBlock blocks={blocks} />
          ))}
      </Grid>
    </PostBase>
  );
}

export default PostDisplay;
